import { commonService } from './commonService';

export const aiSoftwareDevelopmentConsulting = {
  ...commonService,
  name: 'AI Software Development & Consulting',
  serviceType: [
    'AI Software Development',
    'Generative AI Consulting',
    'Artificial Intelligence Product Development',
    'AI Strategy Consulting',
  ],
  description:
    'Boldare provides AI software development and consulting services, specializing in generative AI product development, AI strategy, and helping decision makers leverage the transformative potential of AI technologies.',
};
